enum ContractMaintenancePolicy {
  BASIC = "BASIC",
  AUCTION = "AUCTION",
}

export default ContractMaintenancePolicy;
